export interface AudioItemProps {
  uid: string;
  /** The grid holding this item; its Delete option looks the item up and removes it there. */
  gridId?: string;
  title: string;
  duration: number;
  width?: number;
  height?: number;
  source: string;
  onTitleRenamed?: (newTitle: string) => Promise<void>;
  showThreeDots?: boolean;
  categories?: string[];
  className?: string;
}

export enum AudioItemDropdownItemId {
  RENAME = 'rename',
  DELETE = 'delete',
}
